import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const authHeaders = (token) => ({
  headers: {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  },
});

const safeRequest = async (requestFn) => {
  try {
    const response = await requestFn();
    return response.data;
  } catch (error) {
    return error.response?.data || { cod: error.response?.status || 500, message: 'Error en la conexión', data: null };
  }
};

export const login = async (nombre_usuario, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, { nombre_usuario, password });
    return response.data;
  } catch (error) {
    return error.response?.data || { cod: 500, message: 'Error en la conexión' };
  }
};

export const register = async (nombre_usuario, password, email) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, { nombre_usuario, password, email });
    return response.data;
  } catch (error) {
    return error.response?.data || { cod: 500, message: 'Error en la conexión' };
  }
};

export const getUserProfile = async (token) => {
  return safeRequest(() => axios.get(`${API_URL}/user/profile`, authHeaders(token)));
};

// --- Admin: Clientes ---

export const getClients = async (token) => {
  return safeRequest(() => axios.get(`${API_URL}/clientes`, authHeaders(token)));
};

export const getClientById = async (token, id) => {
  return safeRequest(() => axios.get(`${API_URL}/clientes/${id}`, authHeaders(token)));
};

export const createClient = async (token, data) => {
  return safeRequest(() => axios.post(`${API_URL}/clientes`, data, authHeaders(token)));
};

export const updateClient = async (token, id, data) => {
  return safeRequest(() => axios.put(`${API_URL}/clientes/${id}`, data, authHeaders(token)));
};

export const deleteClient = async (token, id) => {
  return safeRequest(() => axios.delete(`${API_URL}/clientes/${id}`, authHeaders(token)));
};

// --- Admin: Terminales ---

export const getAllTerminals = async (token) => {
  return safeRequest(() => axios.get(`${API_URL}/terminales/admin`, authHeaders(token)));
};

export const getMyTerminals = async (token) => {
  return safeRequest(() => axios.get(`${API_URL}/terminales/getTerminales`, authHeaders(token)));
};

export const createTerminal = async (token, data) => {
  return safeRequest(() => axios.post(`${API_URL}/terminales/admin`, data, authHeaders(token)));
};

export const updateTerminal = async (token, guid, data) => {
  return safeRequest(() => axios.put(`${API_URL}/terminales/admin/${guid}`, data, authHeaders(token)));
};

export const getTerminalRemoteConfig = async (token, guid) => {
  return safeRequest(() => axios.get(`${API_URL}/terminales/admin/${guid}/config`, authHeaders(token)));
};

export const updateTerminalRemoteConfig = async (token, guid, data) => {
  return safeRequest(() => axios.put(`${API_URL}/terminales/admin/${guid}/config`, data, authHeaders(token)));
};

export const deleteTerminal = async (token, guid) => {
  return safeRequest(() => axios.delete(`${API_URL}/terminales/admin/${guid}`, authHeaders(token)));
};

export const assignTerminal = async (token, guid, clientId) => {
  return safeRequest(() => axios.post(`${API_URL}/terminales/assign`, { guid, clientId }, authHeaders(token)));
};

export const unassignTerminal = async (token, guid) => {
  return safeRequest(() => axios.post(`${API_URL}/terminales/${guid}/unassign`, {}, authHeaders(token)));
};

export const updateTerminalProfile = async (token, guid, tipo_cultivo, tipo_suelo) => {
  return safeRequest(() => axios.put(`${API_URL}/terminales/${guid}/profile`, { tipo_cultivo, tipo_suelo }, authHeaders(token)));
};

// --- Admin: Usuarios ---

export const getAllUsers = async (token) => {
  return safeRequest(() => axios.get(`${API_URL}/user/admin`, authHeaders(token)));
};

export const createUserAdmin = async (token, data) => {
  return safeRequest(() => axios.post(`${API_URL}/user/admin`, data, authHeaders(token)));
};

export const updateUserAdmin = async (token, id, data) => {
  return safeRequest(() => axios.put(`${API_URL}/user/admin/${id}`, data, authHeaders(token)));
};

export const deleteUserAdmin = async (token, id) => {
  return safeRequest(() => axios.delete(`${API_URL}/user/admin/${id}`, authHeaders(token)));
};

// --- Admin: Planes y contratos ---

export const getPlans = async (token) => {
  return safeRequest(() => axios.get(`${API_URL}/planes`, authHeaders(token)));
};

export const getContracts = async (token) => {
  return safeRequest(() => axios.get(`${API_URL}/contratos`, authHeaders(token)));
};

export const setClientPlan = async (token, clientId, planId) => {
  return safeRequest(() => axios.post(`${API_URL}/contratos/set-plan`, { clientId, planId }, authHeaders(token)));
};

// --- Cliente: Graficos y mapa ---

export const getTerminalSummaries = async (token, days = 7) => {
  return safeRequest(() => axios.get(`${API_URL}/lecturas/terminales?days=${days}`, authHeaders(token)));
};
